import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [isDark, setIsDark] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Load theme preference from localStorage
  useEffect(() => {
    try {
      const savedTheme = localStorage.getItem('theme');
      setIsDark(savedTheme === 'dark');
    } catch (error) {
      console.error('Error fetching theme preference:', error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  // Update theme preference to localStorage and apply theme
  useEffect(() => {
    if (!isLoading) {
      try {
        localStorage.setItem('theme', isDark ? 'dark' : 'light');
      } catch (error) {
        console.error('Error saving theme preference:', error);
      }
    }

    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [isDark, isLoading]);

  const toggleTheme = () => {
    setIsDark(prev => !prev);
  };

  const value = {
    isDark,
    toggleTheme,
    theme: isDark ? 'dark' : 'light'
  };

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}; 